// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Gz-z","tooltipWrapper":"Hz-z","icon":"Iz-z","tooltip":"Jz-z","content":"Kz-z"};